// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// Load from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase only if config is valid
let app = null;
let auth = null;
let analytics = null;

// Check if Firebase config is valid
const hasValidConfig = firebaseConfig.apiKey && 
                       firebaseConfig.apiKey !== 'undefined' && 
                       firebaseConfig.apiKey.trim() !== '' &&
                       firebaseConfig.projectId &&
                       firebaseConfig.projectId !== 'undefined';

if (hasValidConfig) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);

    // Session-scoped auth: store auth state in sessionStorage so it is cleared
    // when the browser/tab closes (instead of Firebase's default
    // browserLocalPersistence, which survives restarts). This also migrates any
    // already-persisted local session to session storage. Keeps you logged in
    // across a page refresh, but not across a browser close. Pairs with the
    // 15-minute idle auto-logout in components/Admin.js.
    setPersistence(auth, browserSessionPersistence).catch((err) =>
      console.error('Failed to set session-only auth persistence:', err)
    );

    // Initialize Analytics (only in browser environment)
    if (typeof window !== 'undefined') {
      try {
        analytics = getAnalytics(app);
      } catch (error) {
        console.warn('Analytics initialization failed:', error);
      }
    }
  } catch (error) {
    console.error('Firebase initialization failed:', error);
  }
} else {
  console.warn('Firebase configuration not found. Please check your .env file.');
}

export { auth, analytics };
export default app;

